/**
 * Pluggable implied-volatility toolkit.
 *
 * - `solveImpliedVolatility` — pick an engine (bisection | newton | brent),
 *   inject a pricer, get back IV + diagnostics.
 * - `bisection` / `newton` / `brent` — the bare numerical root-finders.
 * - `IV_METHODS` — the list of engines, for iterating in tests/benchmarks.
 */
export { solveImpliedVolatility, IV_METHODS } from './solvers';
export { bisection, newton, brent } from './rootFinders';
export type { RootFinderResult, BracketingOptions, NewtonOptions } from './rootFinders';
export type {
  IVMethod,
  IVFailureReason,
  ImpliedVolatilityInput,
  ImpliedVolatilityResult,
} from './types';
